<div class="zag-stepper-dialog">
  <header class="zag-stepper-dialog__header">
    <h2 [id]="titleId" class="zag-stepper-dialog__title">{{ titleKey() | translate: titleParams() }}</h2>
    <span class="zag-stepper-dialog__position">
      {{ stepPositionKey() | translate: { current: activeIndex() + 1, total: stepCount() } }}
    </span>
    <button
      type="button"
      zagButton="outlined"
      zagType="secondary"
      zagSize="lg"
      class="zag-stepper-dialog__close"
      [attr.aria-label]="'common.close' | translate"
      [disabled]="isSubmitting()"
      (click)="onCancel()"
    >
      <span zagIcon="close" aria-hidden="true"></span>
    </button>
  </header>

  <ol class="zag-stepper-dialog__steps" [attr.aria-labelledby]="titleId">
    @for (step of steps(); track step.id; let i = $index) {
      <li class="zag-stepper-dialog__step">
        <button
          type="button"
          zagButton="bare"
          class="zag-stepper-dialog__step-btn"
          [class.zag-stepper-dialog__step-btn--active]="step.id === activeStepId()"
          [class.zag-stepper-dialog__step-btn--done]="i < activeIndex()"
          [attr.aria-current]="step.id === activeStepId() ? 'step' : null"
          [attr.aria-label]="
            (step.labelKey | translate: step.labelParams) + ', ' + (stepPositionKey() | translate: { current: i + 1, total: stepCount() })
          "
          [disabled]="isSubmitting()"
          (click)="goToStep(step.id)"
        >
          <span class="zag-stepper-dialog__step-index" aria-hidden="true">{{ i + 1 }}</span>
          <span class="zag-stepper-dialog__step-label">{{ step.labelKey | translate: step.labelParams }}</span>
        </button>
      </li>
    }
  </ol>

  <section
    class="zag-stepper-dialog__body"
    tabindex="0"
    [attr.aria-label]="
      (activeStep().labelKey | translate: activeStep().labelParams) +
      ', ' +
      (stepPositionKey() | translate: { current: activeIndex() + 1, total: stepCount() })
    "
  >
    @if (stepContent(); as content) {
      <ng-container *ngTemplateOutlet="content; context: { $implicit: activeStepId() }" />
    }
  </section>

  <footer class="zag-stepper-dialog__actions">
    <button type="button" zagButton="outlined" zagType="secondary" [disabled]="isSubmitting()" (click)="onCancel()">
      {{ cancelLabelKey() | translate }}
    </button>
    <span class="zag-stepper-dialog__spacer"></span>
    <button type="button" zagButton="outlined" zagType="secondary" [disabled]="isFirst() || isSubmitting()" (click)="back()">
      <span zagIcon="chevron-left"></span>
      {{ backLabelKey() | translate }}
    </button>
    @if (isLast()) {
      <button type="button" zagButton zagType="primary" [zagLoading]="isSubmitting()" [disabled]="!canGoNext()" (click)="onSubmit()">
        {{ submitLabelKey() | translate: submitLabelParams() }}
      </button>
    } @else {
      <button type="button" zagButton zagType="primary" [disabled]="!canGoNext() || isSubmitting()" (click)="next()">
        {{ nextLabelKey() | translate }}
        <span zagIcon="chevron-right" zagEnd></span>
      </button>
    }
  </footer>
</div>
